<script setup>
import { useSettingsStore } from '~/stores/settings';
import { useLocalePath } from '#i18n';

const localePath = useLocalePath();
const settingsStore = useSettingsStore();
</script>

<template>
  <footer
    class="bg-[var(--p-background-50)] px-6 py-16 text-[var(--p-background-950)] md:px-12"
  >
    <div
    class="mx-auto max-w-7xl border-t border-[var(--p-background-800)] pt-16">
      <!-- Logo ve Açıklama Bölümü -->
      <div
      class="mb-12 grid grid-cols-1 gap-12 md:grid-cols-4">
        <div
        data-aos="fade-up"
          data-aos-duration="500"

        class="flex flex-col justify-between md:items-center">
          <div
          data-aos="fade-up"
          data-aos-duration="500"

          class="text-center">
            <NuxtLink
              :to="localePath('index')"
              class="mb-8 flex w-full items-center justify-center"
            >
              <img
                v-if="!settingsStore.isDarkMode"
                src="/media/logo-full.webp"
                width="100"
                height="auto"
                alt="Cobe Logo"
              />
              <img
                v-else
                src="/media/logo-full-blue.webp"
                width="100"
                height="auto"
                alt="Cobe Logo"
              />
          </NuxtLink>
            <p class="mb-6 text-sm opacity-80">
              {{ $t('components.layouts.footer.description') }}
            </p>
          </div>

          <!-- Sosyal Medya İkonları -->
          <div
          data-aos="fade-up"
          data-aos-duration="500"

          class="flex items-center space-x-4 max-md:justify-center">
            <!-- <PrimeButton
              as="a"
              href="#"
              target="_blank"
              icon="pi pi-twitter"
              text
              size="large"
            /> -->
            <PrimeButton
              as="a"
              href="https://www.instagram.com/cobe1.bee/"
              target="_blank"
              icon="pi pi-instagram"
              text
              size="large"
            />
            <PrimeButton
              as="a"
              href="https://www.tiktok.com/@user5103634276623"
              target="_blank"
              icon="pi pi-tiktok"
              text
              size="large"
            />
            <PrimeButton
              as="a"
              href="https://www.facebook.com/profile.php?id=61573918164260"
              target="_blank"
              icon="pi pi-facebook"
              text
              size="large"
            />
            <!-- <PrimeButton href="#" class="text-[var(--p-background-0)] hover:text-[var(--p-primary-400)] transition-colors">
              <i class="pi pi-youtube" style="font-size: 1.5rem;"></i>
            </PrimeButton> -->
          </div>
        </div>

        <!-- Ürün Bölümü -->
        <div
        data-aos="fade-up"
          data-aos-duration="500"

        class="col-span-1 md:flex md:justify-center">
          <div
          data-aos="fade-up"
          data-aos-duration="500"

          class="text-left">
            <h3 class="mb-3 text-lg font-medium text-center">
              {{ $t('components.layouts.footer.quickLinks') }}
            </h3>
            <ul>
              <li>
                <PrimeButton
                  as="router-link"
                  :to="localePath('index')"
                  link
                  :label="$t('components.layouts.footer.home')"
                />
              </li>
              <li>
                <PrimeButton
                  as="router-link"
                  :to="localePath({name: 'profession', params: {profession: 'lawyer'}})"
                  link
                  :label="$t('components.layouts.footer.legalAi')"
                />
              </li>
              <li class="text-center">
                <PrimeButton
                  as="router-link"
                  :to="localePath({name: 'chat-profession', params: {profession: 'lawyer'}})"
                  link
                  :label="$t('components.layouts.footer.legalConsultation')"
                />
              </li>
              <li>
                <PrimeButton
                  as="router-link"
                  :to="localePath('pricing')"
                  link
                  :label="$t('components.layouts.footer.pricing')"
                />
              </li>
            </ul>
          </div>
        </div>

        <!-- Kaynaklar Bölümü -->
        <div
        data-aos="fade-up"
          data-aos-duration="500"

        class="col-span-1 md:flex md:justify-center">
          <div
          data-aos="fade-up"
          data-aos-duration="500"

          class="text-left max-md:text-center">
            <h3 class="mb-3 text-lg font-medium text-center">
              {{ $t('components.layouts.footer.legal') }}
            </h3>
            <ul>
              <li>
                <PrimeButton
                  as="router-link"
                  :to="localePath('terms')"
                  link
                  :label="$t('components.layouts.footer.terms')"
                />
              </li>
              <li class="text-center">
                <PrimeButton
                  as="router-link"
                  :to="localePath('privacy')"
                  link
                  :label="$t('components.layouts.footer.privacy')"
                />
              </li>
              <li>
                <PrimeButton
                  as="router-link"
                  :to="localePath('cookies')"
                  link
                  :label="$t('components.layouts.footer.cookies')"
                />
              </li>
            </ul>
          </div>
        </div>

        <!-- Yasal Bölümü -->
        <div
        data-aos="fade-up"
          data-aos-duration="500"

        class="col-span-1 md:flex md:justify-center">
          <div
          data-aos="fade-up"
          data-aos-duration="500"

          class="text-left max-md:text-center">
            <h3 class="mb-3 text-lg font-medium text-center">
              {{ $t('components.layouts.footer.contact') }}
            </h3>
            <ul>
              <li>
                <PrimeButton
                  as="router-link"
                  :to="localePath('contact')"
                  link
                  label="contact@cobe1.com"
                  style="text-transform: lowercase"
                />
              </li>
              <li class="text-sm opacity-80 text-center">
                {{ $t('components.layouts.footer.company') }}
              </li>
              <li class="text-sm opacity-80 text-center">
                {{ $t('components.layouts.footer.registrationNumber') }}
              </li>
              <li class="text-sm opacity-80 text-center">
                {{ $t('components.layouts.footer.address1') }}
              </li>
              <li class="text-sm opacity-80 text-center">
                {{ $t('components.layouts.footer.address2') }}
              </li>
            </ul>

          </div>
        </div>
      </div>

      <!-- Alt Kısım - Telif Hakkı -->
      <div
        data-aos="fade-up"
        data-aos-duration="500"
        class="border-t border-[var(--p-background-800)] pt-8 pb-2 text-sm opacity-70 max-md:text-center"
      >
        <p>
          {{ new Date().getFullYear() }} COBE1
          {{ $t('components.layouts.footer.allRightsReserved') }}

        </p>
      </div>
    </div>
  </footer>
</template>

<style scoped>
ul {
  display: flex;
  flex-direction: column;
  align-items: center;
}
ul > li {
  text-align: center;
}
</style>